import * as types from "../../ActionType";

const initState = {
    page_list: {},
    loadingPageList: true,
    one_account: {},
    loadingOneAccount: true,
    accounts: [],
    loadingAccounts: true,
    statementsByAccount: [],
    loadingStatementsByAccount: true,
    dataReport: null,
    loadingDataReport: true
}

const AccountsReducer = (state = initState, action) => {
    switch (action.type) {
        case types.PAGE_LIST_ACCOUNTS:
            return { ...state, page_list: action.payload, loadingPageList: false }
        case types.ADD_ACCOUNT:
            return { ...state, loadingAccounts: true }
        case types.GET_ACCOUNTS:
            return { ...state, accounts: action.payload, loadingAccounts: false }
        case types.GET_STATEMENTS_BY_ACCOUNT:
            return { ...state, statementsByAccount: action.payload, loadingStatementsByAccount: false }
        case types.EMPTY_STATEMENTS_BY_ACCOUNT:
            return { ...state, statementsByAccount: action.payload, loadingStatementsByAccount: true }
        case types.GET_STATEMENTS_REPORT_BY_ACCOUNT:
            return { ...state, dataReport: action.payload, loadingDataReport: false }
        case types.EMPTY_STATEMENTS_REPORT_BY_ACCOUNT:
            return { ...state, dataReport: action.payload, loadingDataReport: true }
        case types.GET_ONE_ACCOUNT:
            return { ...state, one_account: action.payload, loadingOneAccount: false }
        case types.EMPTY_ONE_ACCOUNT:
            return { ...state, one_account: action.payload, loadingOneAccount: true }
        case types.DELETE_ACCOUNT:
            return { ...state }
        case types.EDIT_ACCOUNT:
            return { ...state, loadingAccounts: true }
        default:
            return state;
    }
};

export default AccountsReducer;


